import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faEdit,
  faEye,
  faTrash,
  faCopy,
  faClipboardList,
  faChartBar,
  faSignOutAlt,
  faPlus,
  faEllipsisVertical,
  faPen,
  faPlay,
  faPause,
  faPenToSquare,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faEye,
  faEdit,
  faTrash,
  faCheck,
  faCopy,
  faClipboardList,
  faChartBar,
  faSignOutAlt,
  faPlus,
  faEllipsisVertical,
  faPen,
  faPlay,
  faPause,
  faPenToSquare
);